import React from 'react';

export default function BalanceSheet() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Balance Sheet</h1>
      <p className="text-gray-500">Halaman Balance Sheet</p>
    </div>
  );
}
